/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Page404 from './components/core/Page404';
import AcceptInvite from './components/core/AcceptInvite';
import Adrift from './components/core/Adrift';
import Dashboard from './components/core/Dashboard';
import Navigation from './components/core/Navigation';
import Login from './components/core/Login';
import AppContext from './components/core/AppContext';
import PrivateRoute from './components/core/PrivateRoute';

import './css/App.css';

const App = ({ app }) => (
  <Router>
    <AppContext app={app}>
      <Navigation />

      <Switch>
        <Route path="/login" component={Login} />
        <PrivateRoute path="/invite/:token" component={AcceptInvite} />
        <PrivateRoute path="/adrift" component={Adrift} />
        <PrivateRoute path="/" component={Dashboard} />
        <Route component={Page404} />
      </Switch>

      <ToastContainer />

      <div id="footer">
        &copy; Nightingale
        {
          process.env.NODE_ENV.toLowerCase() === 'development'
          ? <small> You are running this application in <b>{process.env.NODE_ENV}</b> mode.</small>
          : null
        }
      </div>
    </AppContext>
  </Router>
);

App.propTypes = {
  app: PropTypes.object.isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js